import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import { Reveal, Stagger, StaggerItem, Counter } from "@/components/motion";
import WhyChooseUs from "@/sections/WhyChooseUs";
import ProcessTimeline from "@/sections/ProcessTimeline";
import CTABanner from "@/components/CTABanner";
import { ABOUT_VALUES, STATS } from "@/data/site";

export default function AboutPage() {
  return (
    <>
      <SEO
        title="About Us — Digital Marketing Company Bengaluru"
        description="DiziTeQ Innovative Solutions is a Bengaluru-based digital marketing agency helping local businesses grow with premium websites, Local SEO, branding and advertising."
        path="/about"
      />
      <PageHeader
        eyebrow="About DiziTeQ"
        title="We help local businesses become the brand customers"
        highlight="trust and choose"
        subtitle="Founded in Bengaluru, DiziTeQ Innovative Solutions blends premium design, engineering and data-driven marketing to deliver measurable growth for local businesses."
      />

      <section className="dq-container py-14">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal>
            <div className="overflow-hidden rounded-[2rem] border border-dq-line bg-white dq-shadow-soft">
              <img src="/generated/growth.png" alt="Abstract growth illustration representing DiziTeQ's marketing results" className="w-full object-cover" loading="lazy" />
            </div>
          </Reveal>
          <div>
            <Reveal>
              <p className="label-eyebrow mb-4">Our story</p>
            </Reveal>
            <Reveal delay={0.06}>
              <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tighter text-dq-ink sm:text-4xl">
                Premium craft meets real business growth.
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-dq-muted">
                <p>Too many local businesses are held back by cheap websites and marketing that doesn&rsquo;t move the needle. We started DiziTeQ to change that — bringing agency-grade design and performance marketing to businesses across Bengaluru.</p>
                <p>We obsess over the details that build trust and the metrics that grow revenue. Every project is engineered to help you get found, get chosen and grow — sustainably.</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="dq-container pb-14">
        <div className="grid grid-cols-2 gap-4 rounded-[2rem] border border-dq-line bg-white p-8 lg:grid-cols-4 lg:p-10">
          {STATS.map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-display text-3xl font-extrabold text-dq-orange sm:text-4xl">
                <Counter to={s.value} suffix={s.suffix} decimals={s.decimals || 0} />
              </div>
              <div className="mt-2 text-sm font-medium text-dq-muted">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="dq-container pb-6">
        <p className="label-eyebrow mb-4 text-center">What we value</p>
        <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {ABOUT_VALUES.map((v) => (
            <StaggerItem key={v.title}>
              <div className="h-full rounded-3xl border border-dq-line bg-white p-6">
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-dq-orange/10 text-dq-orange">
                  <v.icon className="h-6 w-6" />
                </span>
                <h3 className="mt-4 font-display text-lg font-bold text-dq-ink">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-dq-muted">{v.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <WhyChooseUs />
      <ProcessTimeline />
      <div className="py-10"><CTABanner /></div>
    </>
  );
}
